import React from 'react'
import { initializeApollo } from '@gql/client'
import { PaginaDocument, SoluzioniDocument } from '@gql/graphql'
import { NextWrapper } from 'data-fetching-wrapper'
import { SoluzioniTemplate } from '@components/templates'

const SoluzioniHub = ({ pagina, soluzioni }) => (
  <SoluzioniTemplate soluzioni={soluzioni} pagina={pagina} />
)

export const getStaticProps = NextWrapper.getStaticProps(
  async ({ locale, preview, previewData }) => {
    const client = initializeApollo(locale)

    const headers = preview && previewData?.headers ? { cookie: previewData.headers } : {}

    const {
      data: { pagina },
    } = await client.query({
      query: PaginaDocument,
      variables: { chiave: 'soluzioni', preview },
      context: {
        headers,
      },
    })

    if (!pagina) {
      return {
        notFound: true,
      }
    }

    const {
      data: { soluzioni },
    } = await client.query({
      query: SoluzioniDocument,
    })

    return {
      props: { pagina, soluzioni },
      revalidate: 60 * 20,
    }
  },
  '/soluzioni'
)

export default SoluzioniHub
